<!-- After "Link anfordern". Worded for both cases on purpose — the API does
     not say whether the address has an account. -->
<main class="onb onb--sheet">

  <header class="onb__head">
    <p class="belturo-eyebrow onb__head-eyebrow"><%= _lcs( 'Konto' ) %></p>
    <h1 class="onb__head-title"><em><%= _lcs( 'Schau in dein Postfach' ) %></em></h1>
    <p class="onb__head-sub"><%= _lcs( 'Der Link ist 2 Stunden gültig.' ) %></p>
  </header>

  <div class="onb__scroll onb__done">
    <span class="onb-done__icon"><i class="icon icon--mail"></i></span>

    <p class="onb-done__lead">
      <%= _lcs( 'Falls zu {email} ein Konto existiert, haben wir dir einen Link zum Zurücksetzen geschickt.', { email: email } ) %>
    </p>

    <p class="onb-note">
      <i class="icon icon--info"></i>
      <span><%= _lcs( 'Nichts angekommen? Sieh im Spam-Ordner nach — die Nachricht kann einen Moment brauchen.' ) %></span>
    </p>
  </div>

  <footer class="onb__foot onb__foot--bordered onb__foot--form">
    <button class="btn btn--primary btn--lg btn--block" type="button" data-id="to-login"><%= _lcs( 'Zur Anmeldung' ) %></button>
  </footer>

</main>
